const state = {
    // 登录成功获取的信息
    loginInfos: window.localStorage.getItem('loginInfos') ? JSON.parse(window.localStorage.getItem('loginInfos')) : '',
    // 用户个人资料
    userInfos: window.localStorage.getItem('userInfos') ? JSON.parse(window.localStorage.getItem('userInfos')) : '',
    // 系统配置
    sysConfig: window.localStorage.getItem('sysConfig') ? JSON.parse(window.localStorage.getItem('sysConfig')) : {},
    // 公共配置
    publicConfig: window.localStorage.getItem('publicConfig') ? JSON.parse(window.localStorage.getItem('publicConfig')) : {},
    // 提交卖币成功后
    sellInfos: window.localStorage.getItem('sellInfos') ? JSON.parse(window.localStorage.getItem('sellInfos')) : {
        avatar: '',
        pay_type: '',
        type: '',
        currency: '',
        id:'',
        info_status: 1, // 1是新增 2是修改 3是删除
        status: 1
    },
    // 新订单提醒
    orderRemind: window.localStorage.getItem('haveNewOrder') ? JSON.parse(window.localStorage.getItem('sellInfos')) : {
        order_sn: '',
        type: ''
    },
    // 未处理订单数
    untreatedNum: 0,
    // 卖家确认打币后，ws推送的买卖双方金额变化
    moneyChangeInfos: window.localStorage.getItem('moneyChangeInfos') ? JSON.parse(window.localStorage.getItem('moneyChangeInfos')) : {
        currency: '',
        sell_currency: '',
        freeze_currency: ''
    },
    // 已实名
    isName: false,
    // 用户金额
    memberAmountObj:  window.localStorage.getItem('memberAmountObj') ? JSON.parse(window.localStorage.getItem('memberAmountObj')) : {
        currency_money: '',
        sell_money: '',
        trade_money: ''
    },
    // 主题对应的图片，默认为黑色皮肤
    themeImgs: window.localStorage.getItem('themeImgs') ? window.localStorage.getItem('themeImgs') : 'green',
    // 默认皮肤为黑金色
    theme: window.localStorage.getItem('theme') ? window.localStorage.getItem('theme') : 'green',
    // 从综合传递过来的真实姓名
    actualName: window.sessionStorage.getItem('actualName') ? window.sessionStorage.getItem('actualName') : '',
    showServicePopup: false, // 客服面板
    globalSiteTheme: localStorage.getItem('globalSiteTheme') || 'green',
    //  火币网实时汇率
    realTimeRate: '',
    paymentDialogFlag: false, //  收付款弹框开关
    aboutUsDialogFlag: false, //  关于我们弹框开关
    loginRegisterInfo: { flag: false, type: 1 }, //  登录注册弹框开关
    isApp: window.Certification && window.Certification.scanQRCode || window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.scanQRCode, // 是否嵌套在app壳里
    isAndroid: window.Certification && window.Certification.scanQRCode, // 是否是安卓App
    isIos: window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.scanQRCode, // 是否是IOS App
    quickBuyNotify: {},
    isScanSuccess: false,
    isScanShow: false,
    quickSellNotify: sessionStorage.getItem('quickSellNotify') || '0',    //  0：关闭，1：拉单成功，2：收到socket消息，3：买家已支付，4：订单取消， 6: 智能匹配订单关闭无法匹配到订单
}

export default state
